import { useEffect, useRef, useState } from "react";
import { Box, Button, Menu, Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";

import TextField from "../TextField";

import {
  IProductHistory,
  IPurchase,
} from "../../features/productAnalyzer/productAnalyzer.types";
import { createProductPurchase } from "../../services/apiV2";
import { INTERNAL_SERVER_ERROR } from "../../constants";

interface IPurchaseMenuProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  data?: IPurchase[];
  meta: {
    asin: string;
    salePrice: number;
    costPrice: number;
  };
  onClose: () => void;
  onPurchase?: (data: IProductHistory) => void;
}

export const PurchaseMenu: React.FC<IPurchaseMenuProps> = ({
  meta,
  open,
  anchorEl,
  data,
  onClose,
  onPurchase,
}) => {
  const [quantity, setQuantity] = useState<number>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const textRef = useRef<HTMLInputElement | null>(null);

  const handleQuantityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuantity(Number(event.target.value));
  };

  const handlePurchase = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (quantity) {
      setIsLoading(true);
      createProductPurchase({ quantity, ...meta })
        .then((response) => {
          setIsLoading(false);
          enqueueSnackbar("Successfully added purchased quantity.", {
            variant: "success",
          });
          onPurchase?.({ ...response.data, type: "purchase" });
          // onPurchase?.({
          //   quantity,
          //   ...meta,
          //   id: String(Math.random()),
          //   createdAt: Date.now(),
          //   type: "purchase",
          // });
          onClose();
          setQuantity(undefined);
        })
        .catch((error) => {
          console.error(error);
          enqueueSnackbar(INTERNAL_SERVER_ERROR, {
            variant: "error",
          });
          onClose();
        });
    }
  };

  useEffect(() => {
    if (open && textRef.current) {
      textRef.current.focus();
    }
  }, [open, textRef.current]);

  return (
    <Menu
      id="purchase-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      slotProps={{
        list: {
          "aria-labelledby": "purchase-button",
        },
      }}
    >
      <Box
        width={"120px"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        gap={"5px"}
      >
        <Typography
          variant="body2"
          sx={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: 12,
          }}
        >
          Purchased QTY
        </Typography>
        <TextField
          type="number"
          ref={textRef}
          value={quantity}
          onChange={handleQuantityChange}
          textAlign="center"
          sx={{ width: "100px" }}
          autoFocus
          slotProps={{
            input: {
              min: 0,
            },
          }}
        />
        <Button
          variant="contained"
          size="small"
          onClick={handlePurchase}
          disabled={!quantity}
          loading={isLoading}
          sx={{ width: "100px" }}
        >
          Add
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={onClose}
          sx={{ width: "100px" }}
        >
          Cancel
        </Button>

        {/* {!!data.length && (
          <Box
            display={"grid"}
            gridTemplateColumns={" 2fr 3fr"}
            sx={{
              fontSize: "11px",
              color: "#000000CC",
              width: "100%",
              maxHeight: "200px",
              textAlign: "center",
              alignItems: "center",
              marginBottom: "-8px",
            }}
          >
            <Box
              sx={{
                height: "100%",
                borderRight: "1px solid #181D1F26",
                fontWeight: 600,
                lineHeight: "20px",
                borderBottom: "1px solid #181D1F26",
                background: "#181D1F0D",
              }}
            >
              Units
            </Box>
            <Box
              sx={{
                height: "100%",
                fontWeight: 600,
                lineHeight: "20px",
                borderBottom: "1px solid #181D1F26",
                background: "#181D1F0D",
              }}
            >
              Date
            </Box>
            {data.map((row, index) => (
              <>
                <Box
                  height={"100%"}
                  borderRight={"1px solid #181D1F26"}
                  borderBottom={
                    index !== data.length - 1 ? "1px solid #181D1F26" : "none"
                  }
                  textAlign={"center"}
                  lineHeight={"20px"}
                >
                  {formatNumber(row.quantity)}
                </Box>
                <Box
                  textAlign={"center"}
                  lineHeight={"20px"}
                  borderBottom={
                    index !== data.length - 1 ? "1px solid #181D1F26" : "none"
                  }
                >
                  {moment(row.createdAt).format("MM/DD/YYYY")}
                </Box>
              </>
            ))}
          </Box>
        )} */}
      </Box>
    </Menu>
  );
};

export default PurchaseMenu;
